import * as React from 'react'
import DateRange from 'src/share/components/DateRange/DateRange'
import { SortBox } from 'src/share/components/Filter/SortBox';

const NewsHeader = ({ dateRange, total, onDatesChange, onDateFocusChange, onLangChange
}) => {
  return (
    <div className="news-header">
      <p>Number of results: {total}</p>
      <div>
        <span className="fa fa-calendar" aria-hidden="true" />
        <DateRange
          onDatesChange={onDatesChange}
          onFocusChange={onDateFocusChange}
          focusedInput={dateRange.focus}
          numberOfMonths={1}
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
        />
      </div>
      <div>
        <SortBox onSort={onLangChange} options={{ en: 'EN', es: 'ES' }} selected={"en"} disabled={false} label={"Language"} />
      </div>
    </div>
  )
}

export default NewsHeader
